import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DebugInfoService {
  initialWidth = window.innerWidth;
  initialHeight = window.innerHeight;
  constructor() {}

  isDevToolClosed(): boolean {
    const timeStart = Date.now();
    eval('debugger');
    eval('debugger');
    const timeEnd = Date.now();
    eval('debugger');
    return (timeEnd - timeStart)< 100;
  }
}
